import { AttributeSelectorType } from "@evergis/api";

import { LayerInfo } from "../../../interfaces/resourceInfo";

export const isHandbookAttribute = (name: string, layerInfo: LayerInfo): boolean => {
  return (
    layerInfo?.configuration?.cardConfiguration?.children?.find(({ attributeName }) => attributeName === name)?.options
      ?.relatedAttributes?.length ||
    layerInfo?.configuration?.attributesConfiguration?.attributes?.some(
      ({ attributeName, attributeSelectorType }) =>
        attributeName === name && attributeSelectorType === AttributeSelectorType.ViewHandBook,
    )
  );
};
